import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'config-eventlogs-child',
    templateUrl: 'config-eventlogs-child.component.html',
    styleUrls : ['eventlogNotify.css']
})

export class ConfigEventlogsChildComponent implements OnInit {
    @Input()
    childMessage : Object;

    constructor() { }

    ngOnInit() {

    }

}